import { Fragment, useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useParams } from "react-router-dom";
import { API_URL, BASE_URL } from './Parametrizaciones.js';

function Propiedades() {
    const params = useParams();
    const [detailsInmueble, setDetailsInmueble] = useState([]);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        Modal.setAppElement('body');

        // Consulta adaptada a api.php
        fetch(`${API_URL}?action=getInmuebleByCodigo&codigo=${params.id}`)
            .then(res => res.json())
            .then(data => {
                setDetailsInmueble(data);
            })
            .catch(err => {
                console.error('Error al obtener inmueble:', err);
            });
    }, [params.id]);

    const handleShare = async (Inmueble) => {
        const shareData = {
            title: `${Inmueble.TIPO_INMUEBLE} en ${Inmueble.MUNICIPIO}`,
            text: `Mira esta propiedad: ${Inmueble.TIPO_INMUEBLE} - Código: ${Inmueble.CODIGO_INMUEBLE}`,
            url: window.location.href,
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (err) {
                console.log('Error al compartir:', err);
            }
        } else {
            try {
                await navigator.clipboard.writeText(window.location.href);
                setCopied(true);
                setTimeout(() => setCopied(false), 2500);
            } catch (err) {
                alert('No se pudo copiar el enlace.');
            }
        }
    };

    // Obtener todas las imágenes válidas en un solo arreglo
    const getInmuebleImages = (Inmueble) => {
        if (!Inmueble) return [];

        const imageKeys = [
            'IMAGEN_PRINCIPAL',
            'IMAGEN_01', 'IMAGEN_02', 'IMAGEN_03', 'IMAGEN_04', 'IMAGEN_05',
            'IMAGEN_06', 'IMAGEN_07', 'IMAGEN_08', 'IMAGEN_09', 'IMAGEN_10',
            'IMAGEN_11', 'IMAGEN_12', 'IMAGEN_13', 'IMAGEN_14', 'IMAGEN_15',
            'IMAGEN_16', 'IMAGEN_17', 'IMAGEN_18', 'IMAGEN_19', 'IMAGEN_20'
        ];

        return imageKeys
            .map(key => Inmueble[key])
            .filter(imgName => imgName && imgName.trim() !== '');
    };

    return (
        <Fragment>
            <div className="aa-title my-4">
                {/* Encabezado Superior / Botón Home */}
                <div className="container-fluid px-4 text-center">
                    <a
                        href="/buscar"
                        className="d-inline-flex align-items-center justify-content-center p-3 bg-light rounded-circle shadow-sm mb-3 home-icon-link"
                    >
                        <svg
                            width="36"
                            height="36"
                            fill="currentColor"
                            className="bi bi-house-fill"
                            viewBox="0 0 16 16"
                            style={{ color: '#59abe3' }}
                        >
                            <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
                            <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
                        </svg>
                    </a>
                    <h2 className="fw-bold text-dark display-6 mb-1">Detalle de la Propiedad</h2>
                    <p className="text-muted fw-light fs-5">Conoce toda la información relacionada con este inmueble</p>
                </div>

                {/* Contenedor Principal de la Propiedad */}
                <div className="container-fluid px-lg-5 my-4">
                    {detailsInmueble.map((Inmueble, index) => (
                        <div
                            key={Inmueble.CODIGO_INMUEBLE || index}
                            className="card border-0 shadow-sm p-4 bg-white mb-4"
                            style={{ borderRadius: '28px' }}
                        >
                            <div className="row g-4 align-items-center">

                                {/* Columna Izquierda: Galería de Fotos Completa con Miniaturas (SIN CAMBIOS) */}
                                <div className="col-12 col-lg-6">
                                    {(() => {
                                        const allImages = getInmuebleImages(Inmueble);

                                        return (
                                            <div>
                                                {/* --- Visor Principal --- */}
                                                <div
                                                    id="myCarousel"
                                                    className="carousel slide overflow-hidden shadow-sm position-relative"
                                                    data-ride="carousel"
                                                    data-interval="false"
                                                    style={{ borderRadius: '24px' }}
                                                >
                                                    <div
                                                        className="carousel-inner"
                                                        style={{
                                                            width: '100%',
                                                            aspectRatio: '4 / 3',
                                                            backgroundColor: '#111',
                                                            borderRadius: '24px',
                                                            overflow: 'hidden'
                                                        }}
                                                    >
                                                        {allImages.map((imgName, idx) => (
                                                            <div
                                                                key={idx}
                                                                className={`item carousel-item ${idx === 0 ? 'active' : ''}`}
                                                                style={{ height: '100%' }}
                                                            >
                                                                <img
                                                                    src={`${BASE_URL}/dbimages/${imgName}`}
                                                                    className="d-block w-100"
                                                                    alt={`Foto Inmueble ${idx + 1}`}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover',
                                                                        objectPosition: 'center'
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {/* Botones de Navegación Redondeados */}
                                                    {allImages.length > 1 && (
                                                        <>
                                                            <a
                                                                className="left carousel-control position-absolute top-50 start-0 translate-middle-y ms-3 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 text-white rounded-circle"
                                                                href="#myCarousel"
                                                                data-slide="prev"
                                                                style={{ width: '45px', height: '45px', textDecoration: 'none' }}
                                                            >
                                                                <i className="fa fa-chevron-left" />
                                                            </a>
                                                            <a
                                                                className="right carousel-control position-absolute top-50 end-0 translate-middle-y me-3 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 text-white rounded-circle"
                                                                href="#myCarousel"
                                                                data-slide="next"
                                                                style={{ width: '45px', height: '45px', textDecoration: 'none' }}
                                                            >
                                                                <i className="fa fa-chevron-right" />
                                                            </a>
                                                        </>
                                                    )}
                                                </div>

                                                {/* --- Tira de Miniaturas Inferiores --- */}
                                                {allImages.length > 1 && (
                                                    <div
                                                        className="d-flex flex-row gap-2 mt-3 overflow-auto py-1"
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            scrollbarWidth: 'thin'
                                                        }}
                                                    >
                                                        {allImages.map((imgName, idx) => (
                                                            <div
                                                                key={idx}
                                                                data-target="#myCarousel"
                                                                data-slide-to={idx}
                                                                className={`flex-shrink-0 ${idx === 0 ? 'active' : ''}`}
                                                                style={{
                                                                    width: '90px',
                                                                    cursor: 'pointer',
                                                                    transition: 'transform 0.2s ease, opacity 0.2s ease'
                                                                }}
                                                            >
                                                                <img
                                                                    src={`${BASE_URL}/dbimages/${imgName}`}
                                                                    alt={`Thumbnail ${idx + 1}`}
                                                                    className="img-thumbnail rounded"
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '60px',
                                                                        objectFit: 'cover',
                                                                        border: '2px solid transparent',
                                                                        padding: '2px'
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </div>

                                {/* Columna Derecha: Detalles del Inmueble (CON BORDES SUAVIZADOS EN TODOS LOS ELEMENTOS) */}
                                <div className="col-12 col-lg-6">
                                    <div
                                        className="card border-0 p-4 shadow-sm"
                                        style={{
                                            backgroundColor: '#fdf8f8',
                                            borderRadius: '24px',
                                            border: '1px solid #f2d6d6'
                                        }}
                                    >
                                        {/* Código de Inmueble Suavizado */}
                                        <div
                                            className="bg-primary text-white px-3 py-2 rounded-pill fw-bold mb-2 d-inline-block text-center mx-auto"
                                            style={{ fontSize: '12px', width: 'fit-content', display: 'block' }}
                                        >
                                            CÓDIGO DEL INMUEBLE: {Inmueble.CODIGO_INMUEBLE}
                                        </div>

                                        <hr style={{ borderColor: '#f2d6d6' }} />

                                        <h2 className="text-danger fw-bold">{Inmueble.TIPO_INMUEBLE}</h2>
                                        <h3 className="fw-bold text-secondary">{Inmueble.OPCION_INMUEBLE}</h3>
                                        <h4 className="fw-bold text-dark">{Inmueble.MUNICIPIO}, {Inmueble.BARRIO}</h4>

                                        <hr style={{ borderColor: '#f2d6d6' }} />

                                        {/* Caja de Precio Suavizada (borderRadius 20px) */}
                                        <div
                                            className="p-3 bg-white shadow-sm text-center mb-4"
                                            style={{ border: '1px solid #f2d6d6', borderRadius: '20px' }}
                                        >
                                            <small className="text-uppercase fw-bold text-muted d-block mb-1" style={{ letterSpacing: '0.5px' }}>
                                                Precio de la Propiedad
                                            </small>
                                            <h2 className="text-secondary fw-bold m-0 display-6">{Inmueble.PRECIO}</h2>
                                        </div>

                                        <hr style={{ borderColor: '#f2d6d6' }} />

                                        <h2 className="text-secondary fw-bold mb-3">Características</h2>

                                        {/* Tarjetas de Características Suavizadas (borderRadius 20px) */}
                                        <div className="mb-4">
                                            <div className="row g-3 text-center">

                                                {/* Área */}
                                                <div className="col-6 col-sm-3">
                                                    <div
                                                        className="p-3 bg-white shadow-sm h-100 d-flex flex-column align-items-center justify-content-center"
                                                        style={{ border: '1px solid #f1e4e4', borderRadius: '20px' }}
                                                    >
                                                        <div
                                                            className="rounded-circle bg-danger fa fa-home d-flex align-items-center justify-content-center mb-2 fs-5"
                                                            style={{ width: '45px', height: '45px', color: 'white' }}
                                                        />
                                                        <div className="fw-bold text-dark fs-5">{Inmueble.AREA}</div>
                                                        <small className="text-muted fw-semibold">m² Área</small>
                                                    </div>
                                                </div>

                                                {/* Habitaciones */}
                                                <div className="col-6 col-sm-3">
                                                    <div
                                                        className="p-3 bg-white shadow-sm h-100 d-flex flex-column align-items-center justify-content-center"
                                                        style={{ border: '1px solid #f1e4e4', borderRadius: '20px' }}
                                                    >
                                                        <div
                                                            className="rounded-circle bg-danger fa fa-bed d-flex align-items-center justify-content-center mb-2 fs-5"
                                                            style={{ width: '45px', height: '45px', color: 'white' }}
                                                        />
                                                        <div className="fw-bold text-dark fs-5">{Inmueble.HABITACIONES}</div>
                                                        <small className="text-muted fw-semibold">Habitaciones</small>
                                                    </div>
                                                </div>

                                                {/* Parqueaderos */}
                                                <div className="col-6 col-sm-3">
                                                    <div
                                                        className="p-3 bg-white shadow-sm h-100 d-flex flex-column align-items-center justify-content-center"
                                                        style={{ border: '1px solid #f1e4e4', borderRadius: '20px' }}
                                                    >
                                                        <div
                                                            className="rounded-circle bg-danger fa fa-car d-flex align-items-center justify-content-center mb-2 fs-5"
                                                            style={{ width: '45px', height: '45px', color: 'white' }}
                                                        />
                                                        <div className="fw-bold text-dark fs-5">{Inmueble.PARQUEADERO}</div>
                                                        <small className="text-muted fw-semibold">Parqueadero</small>
                                                    </div>
                                                </div>

                                                {/* Baños */}
                                                <div className="col-6 col-sm-3">
                                                    <div
                                                        className="p-3 bg-white shadow-sm h-100 d-flex flex-column align-items-center justify-content-center"
                                                        style={{ border: '1px solid #f1e4e4', borderRadius: '20px' }}
                                                    >
                                                        <div
                                                            className="rounded-circle bg-danger fa fa-bath d-flex align-items-center justify-content-center mb-2 fs-5"
                                                            style={{ width: '45px', height: '45px', color: 'white' }}
                                                        />
                                                        <div className="fw-bold text-dark fs-5">{Inmueble.BANOS}</div>
                                                        <small className="text-muted fw-semibold">Baños</small>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <hr style={{ borderColor: '#f2d6d6' }} />

                                        {/* Bloque de Descripción Suavizado (borderRadius 20px) */}
                                        <div
                                            className="bg-white p-3 shadow-sm mb-4"
                                            style={{ border: '1px solid #f1e4e4', borderRadius: '20px' }}
                                        >
                                            <h5 className="text-secondary fw-bold mb-2">Descripción del Inmueble</h5>
                                            <p className="text-muted m-0" style={{ lineHeight: '1.6', fontSize: '15px' }}>
                                                {Inmueble.DESCRIPCION}
                                            </p>
                                        </div>

                                        {/* Acciones / Compartir Suavizado */}
                                        <div className="text-center pt-2">
                                            <button
                                                onClick={() => handleShare(Inmueble)}
                                                className="btn border-0 fw-semibold d-inline-flex align-items-center justify-content-center gap-2 px-4 py-3 shadow-sm"
                                                style={{
                                                    borderRadius: '25px',
                                                    backgroundColor: '#25D366',
                                                    color: 'white',
                                                    fontSize: '15px',
                                                    transition: 'transform 0.2s ease'
                                                }}
                                            >
                                                <i className="fa fa-share-alt fs-5" /> Compartir esta propiedad
                                            </button>
                                            {copied && (
                                                <small className="text-success d-block mt-2 fw-semibold">
                                                    ¡Enlace copiado al portapapeles!
                                                </small>
                                            )}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Fragment>
    )
}

export default Propiedades;